import { Link } from "react-router-dom";
import { productImage } from "@/data/products";

const inr = (n) => `₹${n.toLocaleString("en-IN")}`;

const ProductCard = ({ product }) => {
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="card card-lift"
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <div className="card-img">
        <img
          src={productImage(product.id)}
          alt={product.name}
          loading="lazy"
          onError={(e) => {
            e.currentTarget.style.visibility = "hidden";
          }}
        />
      </div>
      <div className="card-body">
        <div className="card-name" data-testid={`product-name-${product.id}`}>
          {product.name}
        </div>
        <div className="card-price" data-testid={`product-price-${product.id}`}>
          {inr(product.price_inr)}
        </div>
        <div className="card-pitch">{product.pitch}</div>
      </div>
    </Link>
  );
};

export default ProductCard;
